





















import _ from 'lodash'
import moment from 'moment'
import { Provide, Prop, Component } from 'vue-property-decorator'
import { BaseForm } from '@/services/BaseForm'
import { IFormOption, INPUT_TYPES } from '@/components/form/FieldTypes'
import RuleHelper from '@/utils/RuleHelper'
import { Getter, Action } from 'vuex-class'
import { IPatient, IPatientType } from '@/store/modules/views/patient/states'
import { IJob, IJobType } from '@/store/modules/views/job/states'
import { countSunday } from '@/utils/DateHelper'
import { IMonthlyContract } from '@/store/modules/views/monthlyContract/states'
import { TCountCaregiver } from '@/store/modules/views/caregiver/actions'

@Component
export default class CreateJobDialog extends BaseForm<any> {
  @Provide('formName') public formName = 'jobDialog'
  @Prop({ default: '' }) private status!: string
  @Prop() private open!: boolean
  @Prop() private callback!: () => void

  private loading = false
  private options: OptionTable = {
    page: 1,
    sortBy: ['updatedAt'],
    sortDesc: [true],
    itemsPerPage: 99999,
    search: '',
  }
  private countCaregiver: TCountCaregiver

  public hasMonthlyContract: boolean | null = null

  @Getter('patient/patientOptions')
  private patientOptions!: [{ text: string, value: string, userId: string }]

  @Getter('patient/patientLists')
  private patientLists!: IPatient[]

  @Getter('components/level')
  private level!: {
    id?: string,
    mode: string,
  }

  @Getter('center/centerLists')
  private centerLists!: Array<{
      text?: string,
      value?: string,
  }>

  // @Getter('patient/centerId')
  // private centerId!: (patientType: string) => string

  @Getter('patient/userId')
  private userId!: (patientType: string) => string

  @Getter('patient/patientId')
  private patientId!: (patientType: string) => string

  @Getter('patient/patientTypeById')
  private patientTypeById!: {[patientTypeId: string]: IPatientType}

  @Getter('job/jobType')
  private jobType!: (patientTypeId: string) => [{ jobTypeId: string, text: string, period: string[] }]

  @Getter('job/periodLists')
  private periodLists!: (jobType: {period: string[]}) => [{ text: string, value: any }]

  @Getter('workingTime/startWorkingTimeLists')
  private startWorkingTimeLists!: (
    patienTypeId: string, jobType: string, period: string, time: IJob['time'], index: number,
  ) => [{ text: string, value: any }]

  @Getter('workingTime/endWorkingTimeLists')
  private endWorkingTimeLists!: (
    patientTypeId: string, jobType: string, period: string, time: IJob['time'], index: number, startTime: string,
  ) => [{ text: string, value: any }]

  @Getter('workingTime/priceWorkingTimeLists')
  private priceWorkingTimeLists!: (
    patientTypeId: string, jobType: string, period: string, startTime: string, endTime: string,
  ) => [{ text: string, value: any }]

  get dataStore() {
    return this.getByName(this.formName)
  }

  get totalDate() {
    if (this.dataStore.startDate && this.dataStore.endDate) {
      return (
        moment(this.dataStore.endDate).diff(moment(this.dataStore.startDate), 'days') + 1
      ) - ((this.dataStore.excludeDate && this.dataStore.excludeDate.length) || 0)
    }
    return 0
  }

  get createJobDialogOption() {
    return {
      justify: 'start',
      form: this.$refs.form && this.openDialog ? this.$refs.form : {},
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          notValidate: true,
          height: '30',
        },
        saveDraftButton: {
          title: 'บันทึกแบบร่าง',
          action: this.saveDraft,
          loading: this.loading,
          height: '30',
          color: 'primary',
          notValidate: true,
          outlined: true,
        },
        submitButton: {
          title: 'เพิ่มและส่งหาผู้รับบริการ',
          action: this.submitData,
          loading: this.loading,
          height: '30',
          color: 'primary',
        },
      },
    }
  }

  get jobForm(): IFormOption[] {
    const isGroup = this.dataStore && this.dataStore.period && _.includes(this.dataStore.period, 'กะ')
    const time = this.dataStore && this.dataStore.time && this.dataStore.time
    const priceDetail = this.dataStore && this.dataStore.priceDetail && this.dataStore.priceDetail
    const fieldTime = this.dataStore && this.dataStore.fields && this.dataStore.fields.time
    const fieldPriceDetail = this.dataStore && this.dataStore.fields && this.dataStore.fields.priceDetail
    const centerId = this.level.id || (this.dataStore && this.dataStore.centerId)

    return [
      {
        type: INPUT_TYPES.AUTOCOMPLETE,
        col: '12',
        props: {
          name: 'patient',
          label: 'ผู้สูงอายุ/ผู้ป่วย',
          placeholder: 'เลือกผู้สูงอายุ/ผู้ป่วย',
          loading: this.loading,
          isRequired: true,
          returnObject: true,
          rules: [RuleHelper.required],
          options: this.patientOptions,
          on: {
            change: (value) => {
              // reset type
              if (this.dataStore && this.dataStore.period) {
                this.doResetDataStore(
                  ['type', 'period', 'time'],
                  this.startWorkingTimeLists(
                    value.patientTypeId,
                    this.dataStore.type.jobTypeId,
                    this.dataStore.period,
                    time,
                    0,
                  ),
                )
              }
              if (centerId && this.dataStore.startDate && this.dataStore.endDate) {
                this.getMonthlyContract(
                  centerId,
                  value._id,
                  this.dataStore.startDate,
                  this.dataStore.endDate,
                )
              }
            },
          },
        },
      },
      {
        type: INPUT_TYPES.AUTOCOMPLETE,
        col: '12',
        props: {
          name: 'centerId',
          label: 'ศูนย์บริการ',
          placeholder: 'เลือกศูนย์บริการ',
          loading: this.loading,
          isRequired: true,
          isHide: this.level.mode !== 'all',
          rules: [RuleHelper.required],
          options: this.centerLists,
          on: {
            change: (value) => {
              if (this.dataStore.patient && this.dataStore.startDate && this.dataStore.endDate) {
                this.getMonthlyContract(
                  value,
                  this.dataStore.patient._id,
                  this.dataStore.startDate,
                  this.dataStore.endDate,
                )
                this.getCountCaregivers(
                  value, this.dataStore.startDate, this.dataStore.endDate, this.dataStore.excludeDate
                )
              }
            },
          },
        },
      },
      {
        type: INPUT_TYPES.AUTOCOMPLETE,
        col: '12',
        props: {
          name: 'type',
          label: 'ประเภทบริการ',
          placeholder: 'เลือกประเภทบริการ',
          parent: 'patient',
          loading: this.loading,
          isRequired: true,
          returnObject: true,
          disabled: !(this.dataStore && this.dataStore.patient),
          rules: [RuleHelper.required],
          options: this.dataStore && this.dataStore.patient && this.dataStore.patient.patientTypeId
            ? this.jobType(this.dataStore.patient.patientTypeId)
            : [],
          on: {
            change: (value) => {
              // reset period
              if (this.dataStore && this.dataStore.period) {
                this.doResetDataStore(
                  ['period', 'time'],
                  this.startWorkingTimeLists(
                    this.dataStore.patient.patientTypeId,
                    value.jobTypeId,
                    this.dataStore.period,
                    time,
                    0,
                  ),
                )
              }
            },
          },
        },
      },
      {
        type: INPUT_TYPES.SELECT,
        col: '12',
        props: {
          name: 'period',
          label: 'ช่วงเวลา',
          placeholder: 'เลือกช่วงเวลา',
          parent: 'type',
          loading: this.loading,
          isRequired: true,
          disabled: !(this.dataStore && this.dataStore.type),
          rules: [RuleHelper.required],
          options: this.dataStore && this.dataStore.type
            ? this.periodLists(this.dataStore.type)
            : [],
          on: {
            change: (value) => {
              // reset time
              if (this.dataStore && value) {
                this.doResetDataStore(
                  ['time'],
                  this.startWorkingTimeLists(
                    this.dataStore.patient.patientTypeId,
                    this.dataStore.type.jobTypeId,
                    value,
                    time,
                    0,
                  ),
                )
                if (this.dataStore.startDate) {
                  setTimeout(() => this.filterExcludeDate(this.dataStore.startDate, 'startDate'), 100)
                }
              }
            },
          },
        },
      },
      {
        type: INPUT_TYPES.DATE,
        col: '6',
        props: {
          name: 'startDate',
          label: 'วันที่เริ่ม',
          placeholder: 'เลือกวันที่',
          loading: this.loading,
          isRequired: true,
          allowDate: (date) => moment(date).diff(moment(), 'days') > -1,
            // && (this.dataStore.endDate
            //   ? moment(date).diff(moment(this.dataStore.endDate), 'days') < 1
            //   : true
            // ),
          rules: [RuleHelper.required, RuleHelper.date],
          on: {
            change: this.filterExcludeDate,
          },
        },
      },
      {
        type: INPUT_TYPES.DATE,
        col: '6',
        props: {
          name: 'endDate',
          label: 'วันที่สิ้นสุด',
          placeholder: 'เลือกวันที่',
          parent: 'startDate',
          disabled: !(this.dataStore && this.dataStore.startDate),
          loading: this.loading,
          isRequired: true,
          isHide: this.dataStore && _.includes(this.dataStore.period, 'เดือน'),
          allowDate: (date) => moment(date).diff(moment(this.dataStore.startDate), 'days') > -1,
          rules: [RuleHelper.required, RuleHelper.date],
          on: {
            change: this.filterExcludeDate,
          },
        },
      },
      {
        type: INPUT_TYPES.DATE,
        col: '12',
        props: {
          name: 'excludeDate',
          label: 'วันที่ไม่รับบริการ',
          placeholder: 'เลือกวันที่',
          parent: 'endDate',
          disabled: !(this.dataStore && this.dataStore.endDate),
          loading: this.loading,
          multiple: true,
          hideDetail: true,
          allowDate: (date) => (
            (moment(date).diff(moment(this.dataStore.startDate), 'days', true) > 0) &&
            (moment(this.dataStore.endDate).diff(moment(date), 'days', true) > 0)
          ),
          rules: [RuleHelper.required, RuleHelper.date],
          on: {
            change: (value, name) => {
              this.getCountCaregivers(
                this.dataStore.centerId, this.dataStore.startDate, this.dataStore.endDate, value
              )
              this.$store.dispatch(
                'form/updateAttr',
                {
                  formName: this.formName,
                  attrName: name,
                  value: value.sort(),
                },
              )
            },
          },
        },
      },
      {
        type: INPUT_TYPES.DESCRIPTION,
        col: '12',
        props: {
          title: `วันทำงาน ${this.totalDate} วัน หยุด ${this.dataStore.excludeDate && this.dataStore.excludeDate.length || 0} วัน`,
          className: 'mb-2',
        },
      },
      {
        type: INPUT_TYPES.DESCRIPTION,
        col: '12',
        props: {
          title: this.countCaregiver ? `นักบริบาลทั้งหมด: ${this.countCaregiver.total} คน โดนแบน: ${this.countCaregiver.banned} คน พร้อมรับงาน: ${this.countCaregiver.availableMax} คน`: "",
          className: 'mb-4',
        },
      },
      {
        type: INPUT_TYPES.SUBTITLE,
        col: '12',
        props: {
          title: `ตารางเวลา และค่าใช้จ่าย`,
          className: 'font-weight-bold',
        },
      },
      {
        type: INPUT_TYPES.GROUP,
        col: '12',
        props: {
          name: 'time',
          className: 'frame-group',
          isAction: isGroup,
          options: fieldTime && isGroup ? this.doMapOptions(fieldTime, time) : [{
            fields: [
              {
                type: INPUT_TYPES.SELECT,
                col: '3',
                props: {
                  name: 'time[0].startTime',
                  label: 'เวลาเริ่มปฏิบัติงาน',
                  placeholder: 'เลือกเวลาเริ่มปฏิบัติงาน',
                  parent: 'period',
                  loading: this.loading,
                  isRequired: true,
                  isHideDetail: true,
                  disabled: !(this.dataStore && this.dataStore.period),
                  rules: [RuleHelper.required],
                  options: this.dataStore && this.dataStore.period
                    ? this.startWorkingTimeLists(
                      this.dataStore.patient.patientTypeId,
                      this.dataStore.type.jobTypeId,
                      this.dataStore.period,
                      time,
                      0,
                    ) : [],
                },
              },
              {
                type: INPUT_TYPES.SELECT,
                col: '3',
                props: {
                  name: 'time[0].endTime',
                  label: 'เวลาสิ้นสุดปฏิบัติงาน',
                  placeholder: 'เลือกเวลาสิ้นสุดปฏิบัติงาน',
                  parent: 'period',
                  loading: this.loading,
                  isRequired: true,
                  isHideDetail: true,
                  disabled: !(this.dataStore && this.dataStore.period),
                  rules: [RuleHelper.required],
                  options: this.dataStore && this.dataStore.period && time && time[0] && time[0].startTime
                    ? this.endWorkingTimeLists(
                        this.dataStore.patient.patientTypeId,
                        this.dataStore.type.jobTypeId,
                        this.dataStore.period,
                        time,
                        0,
                        time[0].startTime,
                      )
                    : [],
                },
              },
              {
                type: INPUT_TYPES.TEXT,
                col: '3',
                props: {
                  name: 'time[0].people',
                  label: 'จำนวนคน',
                  disabled: !(this.dataStore && this.dataStore.type),
                  defaultValue: time && time[0] && time[0].people
                    ? time[0].people
                    : 1,
                  isHideDetail: true,
                  rules: [RuleHelper.number],
                },
              },
              {
                type: INPUT_TYPES.SELECT,
                col: '3',
                props: {
                  name: 'time[0].workingTime',
                  label: 'ราคาการใช้บริการ',
                  placeholder: 'เลือกราคาการใช้บริการ',
                  parent: 'time',
                  loading: this.loading,
                  isRequired: true,
                  isHideDetail: true,
                  disabled: !(time && time[0] && time[0].startTime && time[0].endTime),
                  rules: [RuleHelper.required],
                  options: time && time[0] && time[0].startTime && time[0].endTime
                    ? this.priceWorkingTimeLists(
                        this.dataStore.patient.patientTypeId,
                        this.dataStore.type.jobTypeId,
                        this.dataStore.period,
                        time[0].startTime,
                        time[0].endTime,
                      )
                    : [],
                },
              },
            ],
          }],
        },
      },
      // {
      //   type: INPUT_TYPES.TEXT,
      //   col: '4',
      //   props: {
      //     name: 'contractPrice',
      //     label: 'ค่าทำสัญญา',
      //     defaultValue: this.dataStore && this.dataStore.contractPrice
      //       ? this.dataStore.contractPrice
      //       : '0',
      //     rules: [RuleHelper.currency],
      //   },
      // },
      // {
      //   type: INPUT_TYPES.TEXT,
      //   col: '4',
      //   props: {
      //     name: 'insurancePrice',
      //     label: 'ค่าประกันล่วงหน้า',
      //     defaultValue: this.dataStore && this.dataStore.insurancePrice
      //       ? this.dataStore.insurancePrice
      //       : '0',
      //     rules: [RuleHelper.currency],
      //   },
      // },
      // {
      //   type: INPUT_TYPES.TEXT,
      //   col: '4',
      //   props: {
      //     name: 'caregiverPrice',
      //     label: 'ค่าจัดส่งนักบริบาล',
      //     defaultValue: this.dataStore && this.dataStore.caregiverPrice
      //       ? this.dataStore.caregiverPrice
      //       : '0',
      //     rules: [RuleHelper.currency],
      //   },
      // },
      // {
      //   type: INPUT_TYPES.TEXT,
      //   col: '3',
      //   props: {
      //     name: 'foodPrice',
      //     label: 'ค่าอาหาร',
      //     defaultValue: this.dataStore && this.dataStore.foodPrice
      //       ? this.dataStore.foodPrice
      //       : '0',
      //     rules: [RuleHelper.currency],
      //   },
      // },
      {
        type: INPUT_TYPES.SWITCHTOGGLE,
        col: '3',
        props: {
          name: 'isPriceDetail',
          label: 'ค่าใช้จ่ายอื่นๆ',
          className: 'ml-1',
          defaultValue: this.dataStore && this.dataStore.isPriceDetail
              ? this.dataStore.isPriceDetail
              : false,
        },
      },
      {
        type: INPUT_TYPES.GROUP,
        col: '12',
        props: {
          name: 'priceDetail',
          className: 'frame-group',
          isHide: this.dataStore && this.dataStore.isPriceDetail
            ? !this.dataStore.isPriceDetail
            : true,
          isAction: true,
          options: fieldPriceDetail ? fieldPriceDetail : [{
            fields: [
              {
                type: INPUT_TYPES.TEXT,
                col: '12',
                props: {
                  name: 'priceDetail[0].text',
                  label: 'รายละเอียด',
                  prefix: '1.',
                  defaultValue: priceDetail && priceDetail[0] && priceDetail[0].text ? priceDetail[0].text : undefined,
                },
              },
              {
                type: INPUT_TYPES.TEXT,
                col: '3',
                props: {
                  name: 'priceDetail[0].price',
                  label: 'ราคา',
                  defaultValue: priceDetail && priceDetail[0] && priceDetail[0].price
                    ? priceDetail[0].price
                    : undefined,
                  rules: [RuleHelper.currency],
                },
              },
              {
                type: INPUT_TYPES.SELECT,
                col: '3',
                props: {
                  name: 'priceDetail[0].unit',
                  label: 'หน่วย',
                  defaultValue: priceDetail && priceDetail[0] && priceDetail[0].unit
                    ? priceDetail[0].unit
                    : undefined,
                  options: [
                    { text: 'ทั้งหมด', value: 'ทั้งหมด' },
                    { text: 'ต่อวัน', value: 'ต่อวัน' },
                  ],
                },
              },
              {
                type: INPUT_TYPES.TEXT,
                col: '3',
                props: {
                  name: 'priceDetail[0].caregiver',
                  label: 'ส่วนของนักบริบาล',
                  suffix: '%',
                  defaultValue: priceDetail && priceDetail[0] && priceDetail[0].caregiver
                    ? priceDetail[0].caregiver
                    : '0',
                  rules: [RuleHelper.number, RuleHelper.percent],
                  on: {
                    change: (data, name) => {
                      this.doAssignPercentValue(this.jobForm, name, data, 'center')
                    },
                  },
                },
              },
              {
                type: INPUT_TYPES.TEXT,
                col: '3',
                props: {
                  name: 'priceDetail[0].center',
                  label: 'ส่วนของศูนย์บริการ',
                  suffix: '%',
                  defaultValue: priceDetail && priceDetail[0] && priceDetail[0].center
                    ? priceDetail[0].center
                    : '0',
                  rules: [RuleHelper.number, RuleHelper.percent],
                  on: {
                    change: (data, name) => {
                      this.doAssignPercentValue(this.jobForm, name, data, 'caregiver')
                    },
                  },
                },
              },
            ],
          }],
        },
      },
    ]
  }

  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', value)
  }

  @Action('patient/getPatientList')
    private getPatientList!: (headerParams: {
    headers: {
      page: number,
      limit: number,
      sortBy: string,
      sortDesc: boolean,
      search: string,
      filter: string,
    },
  }) => void

  @Action('patient/getPatientTypeList')
  private getPatientTypeList!: (headerParams: {
    headers: {
      page: number,
      limit: number,
      sortBy: string,
      sortDesc: boolean,
      search: string,
      filter: string,
    },
  }) => void

  @Action('workingTime/getWorkingTimeList')
  private getWorkingTimeList!: (headerParams: {
    headers: {
      page: number,
      limit: number,
      sortBy: string,
      sortDesc: boolean,
      search: string,
      filter: string,
    },
  }) => void

  @Action('job/postJob')
  private postJob!: (options) => void

  @Action('monthlyContract/getMonthlyContracts')
  private getMonthlyContracts!: (headerParams: any) => Promise<IMonthlyContract[]>

  @Action('caregiver/getCountCaregiver')
  private getCountCaregiver!: (headerParams: any) => Promise<TCountCaregiver>

  private async getCountCaregivers(centerId: string, startDate: string, endDate: string, excludeDate: string[]) {
    this.countCaregiver = await this.getCountCaregiver({headers: {
      centerId, startDate, endDate, excludeDate
    }})
  }

  private async getMonthlyContract(centerId: string, patientId: string, startDate: string, endDate: string) {
    this.hasMonthlyContract = null
    const [contracts] = await Promise.all([
      this.getMonthlyContracts({ headers: { filter: {
        centerId: [{condition: 'is', value: centerId}],
        patientId: [{condition: 'is', value: patientId}],
        endDate: [{
          condition: 'greater than equal',
          value: startDate,
        }],
        startDate: [{
          condition: 'less than equal',
          value: moment(endDate).add(3, 'month').format('YYYY-MM-DD'),
        }],
      } } }),
      // this.getCountCaregiver({centerId, startDate, endDate})
    ])
    // this.countCaregiver = countCaregiver
    this.hasMonthlyContract = !_.isEmpty(contracts)
  }

  private filterExcludeDate(value, name) {
    this.dataStore[name] = value
    const startDate = moment(this.dataStore.startDate)
    let endDate = moment(this.dataStore.endDate)
    if (name === 'startDate') {
      if (_.includes(this.dataStore.period, 'เดือน')) {
        endDate = startDate.clone().add(1, 'month').subtract(1, 'day')
        this.$store.dispatch(
          'form/updateAttr',
          {
            formName: this.formName,
            attrName: 'endDate',
            value: endDate.format('YYYY-MM-DD'),
          },
        )
      } else if (endDate.diff(startDate, 'day', true) < 0) {
        this.$store.dispatch(
          'form/updateAttr',
          {
            formName: this.formName,
            attrName: 'endDate',
            value: '',
          },
        )
      }
    }
    if (endDate.diff(startDate, 'day', true) >= 30) {
      this.getMonthlyContract(
        this.dataStore.centerId,
        this.dataStore.patient._id,
        startDate.format('YYYY-MM-DD'),
        endDate.format('YYYY-MM-DD'),
      )
    } else {
      this.hasMonthlyContract = null
    }
    let excludeDate: string[] = _.filter(
      this.dataStore.excludeDate,
      (date) => moment(date).isBetween(startDate, endDate, null, '()'),
    )
    if (_.includes(this.dataStore.period, 'เดือน')) {
      excludeDate = _.uniq(_.concat(excludeDate, countSunday(startDate, endDate)))
    }
    this.getCountCaregivers(
      this.dataStore.centerId, startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD'), excludeDate
    )
    this.$store.dispatch(
      'form/updateAttr',
      {
        formName: this.formName,
        attrName: 'excludeDate',
        value: excludeDate,
      },
    )
  }

  private async mounted() {
    await Promise.all([
      this.getPatient(),
      this.getPatientType(),
      this.getWorkingTime(),
    ])
  }

  private async getList(lists, filter = {}) {
    this.loading = true
    await lists({
      headers: {
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sortBy: _.get(this.options, 'sortBy[0]', 'createdAt'),
        sortDesc: _.get(this.options, 'sortDesc[0]', true),
        search: Buffer.from(this.options.search).toString('base64'),
        filter: Buffer.from(JSON.stringify(filter)).toString('base64'),
      },
    })
    this.loading = false
  }

  private async getPatient() {
    this.getList(this.getPatientList, {patientTypeId: [{
      condition: 'exists',
      value: true,
    }]})
  }

  private async getPatientType() {
    this.getList(this.getPatientTypeList)
  }

  private async getWorkingTime() {
    this.getList(this.getWorkingTimeList)
  }

  private doMapOptions(lists, time) {
    let arrFileds = []
    arrFileds = _.map(lists, (item, index: number) => {
      return {
        fields: _.map(item.fields, (field) => {
          // tslint:disable-next-line:no-unnecessary-initializer
          let defaultValue = undefined
          let disabled = !(this.dataStore && this.dataStore.type)
          let options = (field.props.options ? field.props.options : undefined)
          const split = _.split(field.props.name, '.')
          if (time && time[index]) {
            disabled = !(this.dataStore && this.dataStore.period)
            if (_.includes(field.props.name, 'startTime')) {
              defaultValue = time[index].startTime
            } else if (_.includes(field.props.name, 'endTime')) {
              defaultValue = time[index].endTime
              options = this.endWorkingTimeLists(
                this.dataStore.patient.patientTypeId,
                this.dataStore.type.jobTypeId,
                this.dataStore.period,
                time,
                index,
                time[index].startTime,
              )
            } else if (_.includes(field.props.name, 'workingTime')) {
              defaultValue = _.pick(time[index], ['price', 'food'])
              disabled = !(time && time[index] && time[index].startTime && time[index].endTime)
              options = this.priceWorkingTimeLists(
                this.dataStore.patient.patientTypeId,
                this.dataStore.type.jobTypeId,
                this.dataStore.period,
                time[index].startTime,
                time[index].endTime,
              )
            } else if (_.includes(field.props.name, 'people')) {
              defaultValue = time[index].people || 1
            }
          } else {
            if (_.includes(field.props.name, 'startTime')) {
              defaultValue = this.dataStore && this.dataStore.period
                ? _.head(this.startWorkingTimeLists(
                    this.dataStore.patient.patientTypeId,
                    this.dataStore.type.jobTypeId,
                    this.dataStore.period,
                    time,
                    index,
                )).value : undefined
            }
          }
          return {
            ...field,
            props: {
              ...field.props,
              name: `${split[0].substring(0, split[0].length - 3)}[${index}].${split[1]}`,
              options,
              defaultValue,
              disabled,
            },
          }
        }),
      }
    })
    return arrFileds
  }

  private doAssignPercentValue(forms, name, data, key) {
    const diff = data && !_.isEmpty(data) ? 100 - _.toInteger(data) : 0
    const filedName = `${_.split(name, '.')[0]}.${key}`
    _.forEach(forms, (item: IFormOption) => {
      if (item.props.options) {
        _.forEach(item.props.options, (subitem: { fields: IFormOption }) => {
          if (subitem.fields) {
            _.forEach(subitem.fields, (field: IFormOption) => {
              if (field.props.name === filedName) {
                field.props.defaultValue = (diff < 0) || (diff >= 100) ? 0 : _.toString(diff)
                this.$store.dispatch(
                  'form/updateAttr',
                  {
                    formName: this.formName,
                    attrName: filedName,
                    value: field.props.defaultValue,
                  },
                )
              }
            })
          }
        })
      }
    })
  }

  private doCheckPrice() {
    if (!this.dataStore.isPriceDetail) {
      this.dataStore.priceDetail = []
    }
  }

  private doResetDataStore(names, optionStartTime: Array<{ text: string, value: any }>) {
    _.forEach(names, (name) => {
      this.$store.dispatch(
        'form/updateAttr',
        {
          formName: this.formName,
          attrName: name,
          value: name === 'time'
            ? _.includes(this.dataStore.time, 'กะ')
              ? _.map(this.dataStore.time, () => {
                  return { startTime: _.head(optionStartTime).value }
                })
              : [{ startTime: _.head(optionStartTime).value }]
            : null,
        },
      )
    })
  }

  private async submitData() {
    this.callApi('รอชำระเงิน', 'บันทึกข้อมูล และส่งหาผู้ใช้สำเร็จ')
  }

  private async saveDraft() {
    this.callApi('แบบร่าง', 'บันทึกแบบร่างสำเร็จ')
  }

  private async callApi(status, alert) {
    this.loading = true
    this.doCheckPrice()
    let data = {
      ...this.dataStore,
      type: this.dataStore.type ? this.dataStore.type.text : '',
      status,
      centerId: this.dataStore.centerId || (this.dataStore.patient ? this.dataStore.patient.centerId : ''),
      userId: this.dataStore.patient ? this.dataStore.patient.userId : '',
      patientId: this.dataStore.patient ? this.dataStore.patient._id : '',
      patientType: this.dataStore.patient ? this.patientTypeById[this.dataStore.patient.patientTypeId].name : '',
      time: _.map(this.dataStore.time, (time) => {
        return {
          ..._.omit(time, ['workingTime']),
          people: time.people ? time.people : 1,
          price: time.workingTime ? time.workingTime.price : '',
          food: time.workingTime ? time.workingTime.food : '',
        }
      }),
    }
    data = this.doConvertStringToInt(data)
    try {
      await this.postJob(data)
      this.updateSnackbar({txt: alert, type: 'success'})
      await this.callback()
      this.closeDialog()
    } catch (error) {
      this.loading = false
    }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }
}
